import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button} from '../../common';
import Gift from '../Gift';

export default class SendGiftModal extends Component {
  static propTypes = {
    onModalClose: PropTypes.func.isRequired,
    sendGift: PropTypes.func.isRequired,
    playerId: PropTypes.string,
    gifts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  };

  static defaultProps = {
    playerId: null,
  };

  state = {
    hasPlayerSelectedGift: false,
    activeGift: null,
  };

  onSendGift = () => {
    const {sendGift, playerId} = this.props;
    const {activeGift} = this.state;

    this.setState({hasPlayerSelectedGift: true});
    sendGift(activeGift, playerId);
  }

  toggleGift = (emoji) => {
    this.setState({activeGift: emoji});
  }

  renderGift = (gift) => {
    const {activeGift} = this.state;
    const isSelected = activeGift && activeGift.id === gift.id;

    return (
      <Gift
        isSelected={isSelected}
        toggleGift={this.toggleGift}
        onSendGift={this.onSendGift}
        key={gift.id}
        gift={gift}
      />
    );
  }

  renderGifts = () => {
    const {gifts} = this.props;
    return (
      <div className="row row_wrap">
        {gifts.map(this.renderGift)}
      </div>
    );
  }

  renderConfirmationContent = () => {
    const {onModalClose} = this.props;

    return (
      <div>
        <div className="row row_gap_m row_center text-xxxx-big">
          The gift has been sent!
        </div>
        <div className="row row_center">
          <Button text="Return to your game" handler={onModalClose}/>
        </div>
      </div>
    );
  }

  render() {
    const {hasPlayerSelectedGift} = this.state;

    return (hasPlayerSelectedGift ?
      this.renderConfirmationContent() :
      this.renderGifts());
  }
}
